<template>
  <section>
    <section :class="$style.institution_wrapper">
      <section :class="$style.wrapper_left">
        <a-progress
          :class="$style.progress"
          :strokeWidth="25"
          :stroke-color="{
            from: '#c5ab80',
            to: '#b39058'
          }"
          :percent="percent"
          status="active"
        >
          <template #format="percent">
            <span>{{ `${percent}%` }}</span>
          </template>
        </a-progress>

        <a-steps
          size="small"
          direction="vertical"
          :current="currentStep4Institution"
          class="steps"
          :class="$style.institution_steps"
          @change="onChange"
        >
          <a-step
            v-for="stepItem in kycStepLists"
            :key="stepItem.view"
            :status="stepItem.status"
            :title="$t(stepItem.title)"
          />
        </a-steps>

        <div :class="$style.question_list">
          <div :class="$style.title">{{ $t("FAQ") }}</div>
          <div :class="$style.list">
            <div :class="$style.item">
              <div :class="$style.question">
                {{ $t("qaList[0].qa") }}
              </div>
              <i18n :class="$style.answer" path="qaList[0].answer">
                <template #here>
                  <router-link :to="routeHere">
                    {{ $t("here") }}
                  </router-link>
                </template>
              </i18n>
            </div>

            <div :class="$style.item">
              <div :class="$style.question">
                {{ $t("qaList[1].qa") }}
              </div>
              <div :class="$style.answer">
                {{ $t("qaList[1].answer") }}
              </div>
            </div>

            <div :class="$style.item">
              <div :class="$style.question">
                {{ $t("qaList[2].qa") }}
              </div>
              <div :class="$style.answer">
                {{ $t("qaList[2].answer") }}
              </div>
            </div>
          </div>
        </div>
      </section>

      <div class="kyc_container" :class="$style.institution_container">
        <a-skeleton active :loading="!token" />
        <keep-alive>
          <component
            v-if="token"
            :is="currentStepView"
            :isBroker="isBroker"
          ></component>
        </keep-alive>
      </div>
    </section>
    <tips-continue />
  </section>
</template>

<i18n>
  {
    "en": {
      "here": "here",
      "qaList":[{
        "qa":"My files are not ready, can I fill out the form partially?",
        "answer":"Sure. Prepare your files and then you can continue filling out the form {here} whenever you are ready."
      },{
        "qa":"Does it take long time to register an account?",
        "answer":"In most cases it takes 10-30 minutes."
      },{
        "qa":"How long will it take for my application to be approved?",
        "answer":"0.5-1 day if we collect all needed information from you.Please check your registration Email and provide requested information if you were asked."
      }]
    },
    "zh": {
      "here": "此处",
      "qaList":[{
        "qa":"我的文件或信息暂时没有准备好，可以先填写部分内容吗？",
        "answer":"当然可以，您可以先准备，然后随时在 {here} 续填。"
      },{
        "qa":"开户表格看起来需要填写较多内容？",
        "answer":"开户表格填写需要30分钟左右;"
      },{
        "qa":"开户审批需要多久？",
        "answer":"如果材料齐全,开户审批通常在半天或1天内完成,注册后请注意查收邮件通知。"
      }]
    }
  }
</i18n>

<script>
import { pick } from "lodash-es";
import { mapActions, mapState } from "vuex";
import { Skeleton, Steps, Progress } from "ant-design-vue";
import TipsContinue from "../TipsContinue";
import GeneralInfo from "./GeneralInfo";
import Representives from "./Representives";
import BeneficialOwners from "./BeneficialOwners";
import Documents from "./Documents";
import BankingInfo from "./BankingInfo";
import Questionnaire from "./Questionnaire";

export default {
  name: "Kyc.Institution.Index",
  data() {
    return {
      percent: 0
    };
  },
  props: {
    isBroker: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState(["token"]),
    ...mapState("KYC", [
      "currentStep4Institution",
      "kycStepLists4Institution",
      "institutionPercentList"
    ]),
    kycStepLists() {
      return this.kycStepLists4Institution.map(n => {
        if (this.isBroker && n.title === "Banking Info") {
          return { ...n, title: "Wallet Info" };
        } else {
          return n;
        }
      });
    },
    currentStepView() {
      return this.kycStepLists[this.currentStep4Institution].view;
    },
    currentStepStatus() {
      return this.kycStepLists[this.currentStep4Institution].status;
    },
    routeHere() {
      return {
        name: "kyc",
        hash: "#continue",
        params: this.$route.params,
        query: pick(this.$route.query, ["role", "code", "remote"])
      };
    }
  },
  components: {
    [Skeleton.name]: Skeleton,
    [Steps.name]: Steps,
    [Steps.Step.name]: Steps.Step,
    [Progress.name]: Progress,
    TipsContinue,
    GeneralInfo,
    Representives,
    BeneficialOwners,
    Documents,
    BankingInfo,
    Questionnaire
  },
  watch: {
    institutionPercentList: {
      handler(value) {
        this.percent = Math.max(...value);
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    ...mapActions("KYC", ["changeApplyType", "changeCurrentStep4Institution"]),
    onChange(stepIndex) {
      let { status } = this.kycStepLists4Institution[stepIndex];
      if (status === "wait") return; // 不可以直接点击状态为wait的step
      this.changeCurrentStep4Institution(stepIndex);
    }
  },
  created() {
    this.changeApplyType(1);
  }
};
</script>

<style lang="scss" module>
.institution_wrapper {
  display: flex;
  // .institution_container {
  //   margin: 0px;
  // }

  .wrapper_left {
    padding-top: 50px;
    padding-left: 66px;
    width: 25%;
    .progress {
      :global(.ant-progress-outer) {
        width: 80%;
        padding-right: 0;
        margin-bottom: 30px;
      }
      :global(.ant-progress-text) {
        span {
          width: 80%;
          height: 25px;
          text-align: center;
          margin: 0 auto;
          position: absolute;
          top: 0;
          left: 0;
          padding: 5px 0px;
          color: $legend-dark-color;
          font-size: 16px;
          font-weight: 500;
        }
      }
    }
    .institution_steps {
      margin-bottom: 200px;
      :global(.ant-steps-item-content) {
        min-height: 64px;
      }
    }

    .question_list {
      .title {
        font-size: 20px;
        font-weight: bold;
        margin-bottom: 30px;
      }
      .list {
        width: 80%;
        .item {
          font-size: 16px;

          &:not(:last-child) {
            margin-bottom: 30px;
          }
          .question {
            color: $legend-theme-color;
            font-weight: 500;
            margin-bottom: 10px;
          }
          .answer {
            span {
              color: $legend-theme-color;
              font-weight: 500;
              cursor: pointer;
              text-decoration: underline;
            }
          }
        }
      }
    }
  }

  .institution_container {
    flex: 1;
  }
}
</style>
